// Splits the string based on the capital letters.
const capitalSplit = (text = '') => {
  if (!text) return '';
  const splitted = text.trim().length ? text.split(/(?=[A-Z])/).reduce((acc, curr) => `${acc}${curr} `, '') : '';

  return splitted.trim();
};

export default capitalSplit;
